import { gql } from "apollo-boost";

const GET_PRESTASHOP_TEMP_PRODUCT_LIST = gql`
  query getTempPrestaShopProductList($input: GetListInput) {
    getTempPrestaShopProductList(input: $input) {
      data {
        count
        tempProductList {
          _id
          name
          image
          isShopifySync
          isSynced
          providerIds
          storeProductId
          status
          updatedAt
          createdAt
        }
      }
      error
      status
    }
  }
`;

export default GET_PRESTASHOP_TEMP_PRODUCT_LIST;
